export default "__VITE_ASSET__d064da27__"